import { render, staticRenderFns } from "./PartnersJoinWrite.vue?vue&type=template&id=338dda1a&scoped=true"
import script from "./PartnersJoinWrite.vue?vue&type=script&lang=js"
export * from "./PartnersJoinWrite.vue?vue&type=script&lang=js"
import style0 from "./PartnersJoinWrite.vue?vue&type=style&index=0&id=338dda1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338dda1a",
  null
  
)

export default component.exports